module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"addBookingLink":"Add booking link","setupPopoverTitle":"Simplify appointment planning","setupPopoverMessage":"Take the back-and-forth out of planning. Sync your Google Calendar, share your link, and meet.","setUpAppointments":"Set up appointments","appointmentSetupSuccess":"Booking link created."}}')
  delete Component.options._Ctor
}
